import { FC } from "react";
import { useIntl } from "react-intl";
import { Button } from "@material-ui/core";
import { DsmIcon } from "@dsm-dcs/design-system-react";
import { Spacer } from "./Spacer";

interface IEditModeButtonsProps {
  isEditing: boolean;
  onEdit: () => void;
  onCancel: () => void;
  editLabel?: string;
  cancelLabel?: string;
  disabled?: boolean;
}

const EditModeButtons: FC<IEditModeButtonsProps> = ({
  isEditing,
  onEdit,
  onCancel,
  editLabel,
  cancelLabel,
  disabled = false,
}) => {
  const intl = useIntl();

  const translatedEditLabel =
    editLabel || intl.formatMessage({ id: "GENERAL.EDIT_INPUT" });
  const translatedCancelLabel =
    cancelLabel || intl.formatMessage({ id: "GENERAL.CANCEL" });

  const baseButtonStyle: React.CSSProperties = {
    textDecoration: "underline",
    placeSelf: "start",
    textTransform: "none",
    display: "flex",
    padding: "0px",
  };

  const iconStyle: React.CSSProperties = {
    paddingRight: "5px",
    height: "24px",
    width: "24px",
  };

  return (
    <div
      style={{
        color: "var(--dsm-color-neutral-darker)",
        left: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!isEditing && (
        <Button
          style={{ ...baseButtonStyle, color: "#0070BA" }}
          onClick={onEdit}
          disabled={disabled}
        >
          <DsmIcon slot="before" name="editor/pencil-01" style={iconStyle} />
          {translatedEditLabel}
        </Button>
      )}

      {isEditing && (
        <>
          <Spacer />
          <Button
            style={{ ...baseButtonStyle, color: "#FF0000" }}
            onClick={onCancel}
            disabled={disabled}
          >
            <DsmIcon
              slot="before"
              name="general/minus-circle"
              style={iconStyle}
            />
            {translatedCancelLabel}
          </Button>
        </>
      )}
    </div>
  );
};

export default EditModeButtons;
